export default "__VITE_ASSET__CJAloSHN__"